import { makeQuery } from "../makeQuery";
import type { AppInfoResponse } from "./info.types";

export const useQueryAppInfo = makeQuery<AppInfoResponse>("/api/info");
